//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractRoomNavModel, AbstractRoomModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";


@PresenterRegistration({
  types: [AbstractRoomNavModel]
})
@Component({
  selector: "room-nav-item",
  standalone: false,
  templateUrl: "./rooms-nav-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomsNavItemComponent<TRoom extends AbstractRoomModel> {
  public data: WritableSignal<AbstractRoomNavModel<TRoom>> = signal<AbstractRoomNavModel<TRoom>>(null);

  public isActive = computed(() => {
    return this.data().items().some(item => item.isChecked());
  });
}
